import { useState, useCallback } from "react";

export default function useBulkActions(activities = []) {
  const [selectedActivities, setSelectedActivities] = useState([]);

  const handleActivitySelection = useCallback((activityId) => {
    setSelectedActivities((prev) =>
      prev.includes(activityId)
        ? prev.filter((id) => id !== activityId)
        : [...prev, activityId]
    );
  }, []);

  const selectAllChecked =
    activities.length > 0 && selectedActivities.length === activities.length;

  const handleSelectAllToggle = useCallback(() => {
    if (selectAllChecked) {
      setSelectedActivities([]);
    } else {
      setSelectedActivities(activities.map((a) => a.id));
    }
  }, [activities, selectAllChecked]);

  const clearSelection = useCallback(() => {
    setSelectedActivities([]);
  }, []);

  return {
    selectedActivities,
    selectAllChecked,
    handleActivitySelection,
    handleSelectAllToggle,
    clearSelection,
    selectedCount: selectedActivities.length,
  };
}
